<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';
import { ARROWS_AI_PLAN_SUPPORT_URL } from 'dashboard/helper/arrowsAiSupport';

const props = defineProps({
  inboxCount: { type: Number, default: 0 },
  locked: { type: Boolean, default: false },
});

const { t } = useI18n();
const route = useRoute();
const router = useRouter();
const dismissed = ref(false);

const showBanner = computed(() => !dismissed.value && props.inboxCount === 0);
const bannerText = computed(() =>
  props.locked
    ? t('ARROWS_AI.OVERVIEW.INBOX_BANNER.QUOTA_TEXT', {
        support: t('ARROWS_AI.OVERVIEW.INBOX_BANNER.CONTACT_SUPPORT'),
      })
    : t('ARROWS_AI.OVERVIEW.INBOX_BANNER.TEXT')
);

const goToInboxes = () => {
  router.push({
    name: 'arrows_ai_assistants_inboxes',
    params: {
      accountId: route.params.accountId,
      assistantId: route.params.assistantId,
    },
  });
};

const contactSupport = () => {
  window.open(ARROWS_AI_PLAN_SUPPORT_URL, '_blank', 'noopener,noreferrer');
};

const bannerAction = computed(() =>
  props.locked
    ? t('ARROWS_AI.OVERVIEW.INBOX_BANNER.CONTACT_SUPPORT')
    : t('ARROWS_AI.OVERVIEW.INBOX_BANNER.ACTION')
);
const handleBannerAction = () => {
  if (props.locked) {
    contactSupport();
    return;
  }
  goToInboxes();
};
</script>

<template>
  <div
    v-if="showBanner"
    class="flex items-center justify-between gap-3 px-3 py-2 text-sm border rounded-xl bg-n-amber-3 border-n-amber-4 text-n-amber-11"
  >
    <div class="flex items-center min-w-0 gap-2">
      <span class="shrink-0 i-lucide-triangle-alert size-4" />
      <span :class="{ truncate: !props.locked }">{{ bannerText }}</span>
    </div>
    <div class="flex items-center gap-1 shrink-0">
      <button
        type="button"
        class="px-3 py-1 rounded-lg bg-n-amber-4 hover:bg-n-amber-5"
        @click="handleBannerAction"
      >
        {{ bannerAction }}
      </button>
      <button
        type="button"
        class="grid rounded-lg size-7 place-content-center hover:bg-n-amber-4"
        :aria-label="t('ARROWS_AI.OVERVIEW.INBOX_BANNER.DISMISS')"
        @click="dismissed = true"
      >
        <span class="i-lucide-x size-4" />
      </button>
    </div>
  </div>
</template>
